import React from 'react';

import { UserComponent } from 'react/UserComponent.jsx';

export function NowPlayingWithPlayersComponent({ player, match, showAlways }) {
	if(!match) {
		return null;
	}
	if(!showAlways && (match.isSearch && match.isSingles())) {
		return null;
	}

	const otherPlayerComponents = [];

	match.setPerspectivePlayer(player);
	for(let otherPlayer of match.getOtherPlayers()) {
		otherPlayerComponents.push(
			<UserComponent
				user={otherPlayer}
				key={otherPlayer.id}
			/>
		);
	}
	match.setPerspectivePlayer(null);

	return (
		<React.Fragment>
			{otherPlayerComponents.length > 0 &&
			<span className="with_players">
					{otherPlayerComponents}
				</span>
			}
			{!showAlways && otherPlayerComponents.length === 0 && match.match_count > 0 &&
			<span className="with_players">
					With No One... yet
				</span>
			}
		</React.Fragment>
	);
}